import produce from 'immer';
import * as actions from './actions';

export const initialState = {
  message: '',
  type: '',
  error: null,
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.ERROR_OCCURED:
      // TODO: 기존 에러에 대해서 잘못된 스낵바를 노출하지 안도록 `action.payload.type`으로 분기 처리
      if (action.payload.type) {
        draft.message = action.payload.message;
        draft.type = action.payload.type;
        draft.error = action.payload.error;
        draft.onRetry = action.payload.onRetry;
      }
      break;
    default:
  }
});

export default reducer;
